import { createSelector } from 'reselect';
import type { CardEditorType } from 'types/story';
import type { AdminReducerState } from 'admin/reducers';
import { validateStory } from 'common/building-blocks';
import { selectEditableStory } from 'admin/reducers/story-editor/selectors';
import { selectCurrentVersion } from 'admin/reducers/version-reducer';
import { injectContentHeight } from 'admin/actions/card-editor/update-editable-card-data';
import { getMergeOfEditableStoryWithCardEditor } from 'admin/actions/card-editor/card-editor-sync';

export const createSelectPublishIssues = () =>
	createSelector(
		[
			selectEditableStory,
			selectCurrentVersion,
			(state: AdminReducerState, isCardEditor: boolean) => (isCardEditor ? state.cardEditor.present : undefined),
		],
		(story, version, cardEditor) => {
			if (!story?.storyVersions[version]) return [];
			const snapshot = cardEditor
				? getMergeOfEditableStoryWithCardEditor(
						story,
						injectContentHeight(cardEditor) as CardEditorType,
						version
					)
				: story;
			return validateStory(snapshot.storyVersions[version].data);
		}
	);
